import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import { createCampaignByAgencyFailure, createCampaignByAgencySuccess } from '../../actions/CreateCampaignActions/createCampaignByAgencyActions';

function* createCampaignByAgency({ payload, callback }) {
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.createCampaignByAgency,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("CREATE_CAMPAIGN_BY_AGENCY_SUCCESS status :", response.data.status);
        console.log("CREATE_CAMPAIGN_BY_AGENCY_SUCCESS data :", response.data.response);
        console.log("CREATE_CAMPAIGN_BY_AGENCY_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            createCampaignByAgencySuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
        if (callback) {
            callback(response.data); // Pass the response data to the callback
        }
    } catch (error) {
        console.log('====================================');
        console.log("CREATE_CAMPAIGN_BY_AGENCY_FAILURE status :", error?.response?.status);
        console.log("CREATE_CAMPAIGN_BY_AGENCY_FAILURE data:", error?.response?.data);
        console.log("CREATE_CAMPAIGN_BY_AGENCY_FAILURE error :", error);
        console.log('====================================');
        yield put(createCampaignByAgencyFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* createCampaignByAgencySaga() {
    yield takeLatest(actionTypes.CREATE_CAMPAIGN_BY_AGENCY_REQUEST, createCampaignByAgency);
}

export default createCampaignByAgencySaga;